import gql from 'graphql-tag';

const BROKER_LIST = gql`
  query Query {
    brokerList {
      broker
    }
  }
`;

export default BROKER_LIST;
